var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"5"}},[_c('ContractSummary',{staticClass:"mt-2",attrs:{"contract":_vm.contract,"contractCategories":_vm.contractCategories}})],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"7"}},[_c('contract-information-form',{ref:"contractInformationForm",attrs:{"contractCategories":_vm.contractCategories}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41a92959","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contracts/ContractInformationDetails.vue
// module id = mWE+
// module chunks = 1